import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../componentCss/webform.css";
import { useNavigate } from "react-router-dom";
import Dashboardheader from "./dashboardheader";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import config from "../../config/config";
import { Link } from "react-router-dom";
import PasswordChangeForm from "../../components/auth/PasswordChangeForm";
import { message } from 'antd';

const ChangePassword = () => {
  const navigate = useNavigate();

  const handleSuccess = (result) => {
    message.success('Password changed successfully!');
    // Optionally redirect after successful password change
    setTimeout(() => {
      navigate(`${config.baseUrl}dashboard`);
    }, 2000);
  };

  const handleCancel = () => {
    navigate(`${config.baseUrl}dashboard`);
  };

  return (
    <>
      <div className="wrapper">
        <div id="content">
          <Container fluid className="p-4">
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <div className="innerhead mb-4">
                  <h5 className="headtitle">Change Password</h5>
                </div>
                <Link to={`${config.baseUrl}dashboard`}>
                  <span style={{ float: "right" }}>
                    Back <BsArrowLeftCircleFill />
                  </span>
                </Link>
              </Col>
            </Row>
            <Row justify="center">
              <Col lg={8} md={12} sm={12} className="">
                <PasswordChangeForm
                  onSuccess={handleSuccess}
                  onCancel={handleCancel}
                  showCancel={true}
                  title="Change Your Password"
                  description="Update your password to keep your account secure"
                />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
